import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { Order, CreditCard } from '@app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  url =  'orders';
  creditCardUrl = 'credit-card';

  orders: { [key:string]: number} = {'empty':0};

  private computedSubject: BehaviorSubject<Order> = new BehaviorSubject<Order>({ totalAmount: 0 });
  public computed$: Observable<Order> = this.computedSubject.asObservable();

  private ccSubject: BehaviorSubject<CreditCard> = new BehaviorSubject<CreditCard>({ id: 0, type: '',bank_name: '',brand: '',country:''});
  public cc$: Observable<CreditCard> = this.ccSubject.asObservable();

  private totalCWTSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  private totalCWT$: Observable<number> = this.totalCWTSubject.asObservable();

  constructor(private config: ConfigService) { }

  public get computedValue(): Order {
    return this.computedSubject.value;
  }

  public get ccValue(): CreditCard {
    return this.ccSubject.value;
  }

  // TODO implement in server
  findById(orderId) {
    this.config.get(`/${this.url}/${orderId}`)
      .subscribe( (value: Order) => this.computedSubject.next(value));    
  }

  // TODO implement in server
  compute(orders: { [key:string]: number}) {
    this.orders = orders;
    const operation = 'compute';
    this.config.post(`/${this.url}`,{ orders, operation })
      .subscribe( (value: Order) => this.computedSubject.next(value));
  }

  getOrderCount(product):number {
    return this.orders[(product.productType || {}).name + product.planTypeCode] || 0;
  }

  getTotalOrders():number {
    const orders = this.orders;
    return Object.keys(orders || {})
      .reduce((count, product) => {
        return count + (orders[product] || 0);
      }, 0);
  }

  removeEmpty():Array<string> {
    const orders = this.orders;
    return Object.keys(orders || {})
      .filter(product => {
        return orders[product] >= 1;
      });
  }

  creditCard(ccPrefix: number) {
    return this.config.get(`/${this.creditCardUrl}/${ccPrefix}`);
  }

  setCCPrefix(ccPrefix: number) {
    this.creditCard(ccPrefix)
    .pipe(tap(value => console.log('payment form order service credit card',value)))
    .subscribe( (value: CreditCard) => this.ccSubject.next(value) )
  }
}
